import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

const GoToStoreButton = dynamic(() => import('./GoToStoreButton'));
const FinishedOfferButtons = dynamic(
  () => import('./GoToStoreButton/FinishedOfferButtons')
);

const ActionButton = ({
  gaEventCategory,
  isFinished,
  mostRelevantKeyword,
  offerCoupon = null,
  offerCta = null,
  offerId,
  offerSlug,
  offerUserVisibility,
}) => {
  if (isFinished) {
    return (
      <FinishedOfferButtons
        gaEventCategory={gaEventCategory}
        mostRelevantKeyword={mostRelevantKeyword}
        offerId={offerId}
        offerSlug={offerSlug}
        offerUserVisibility={offerUserVisibility}
      />
    );
  }

  return (
    <GoToStoreButton
      gaEventCategory={gaEventCategory}
      offerCoupon={offerCoupon}
      offerCta={offerCta}
      offerId={offerId}
      offerSlug={offerSlug}
      offerUserVisibility={offerUserVisibility}
    />
  );
};

ActionButton.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  isFinished: PropTypes.bool.isRequired,
  mostRelevantKeyword: PropTypes.string.isRequired,
  offerCoupon: PropTypes.string,
  offerCta: PropTypes.string,
  offerId: PropTypes.number.isRequired,
  offerSlug: PropTypes.string.isRequired,
  offerUserVisibility: PropTypes.string.isRequired,
};

export default ActionButton;
